import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BrowsePathState = {
    baseCategoryIds: number[];
    /** SEO browse slug last associated with `baseCategoryIds` (resolver fallback / same-slug reuse). */
    lastBrowseCategorySlug: string | null;
};

const initialState: BrowsePathState = {
    baseCategoryIds: [],
    lastBrowseCategorySlug: null,
};

export type SetBrowseBaseCategoryIdsPayload = {
    ids: number[];
    /** Pass the current browse slug on `/c/:browseCategorySlug/*` routes; `null` when not on that route. */
    browseCategorySlug: string | null;
};

export const browsePathSlice = createSlice({
    initialState,
    name: 'browsePath',
    reducers: {
        clearBrowseBaseCategoryIds(state) {
            state.baseCategoryIds = [];
            state.lastBrowseCategorySlug = null;
        },
        setBrowseBaseCategoryIds(state, action: PayloadAction<SetBrowseBaseCategoryIdsPayload>) {
            const { ids, browseCategorySlug } = action.payload;
            state.baseCategoryIds = ids.filter((id) => !Number.isNaN(id) && id > 0);
            if (!browseCategorySlug) {
                state.lastBrowseCategorySlug = null;
                return;
            }
            if (state.baseCategoryIds.length > 0) {
                state.lastBrowseCategorySlug = browseCategorySlug;
            } else {
                state.lastBrowseCategorySlug = null;
            }
        },
    },
});

export const { clearBrowseBaseCategoryIds, setBrowseBaseCategoryIds } = browsePathSlice.actions;
export const browsePathReducer = browsePathSlice.reducer;
